/*titleやdescriptionを更新*/
export function updateMetaHead(title='', desc='') {
	let myTitle = 'STOCKPOINT for MUFG'
	let myDesc = 'ポイントをためて本物の株主へ！株式銘柄などの値動きに連動してポイントが増減するポイント運用サービスです。'
	if (title != '') {
		myTitle = `${title} | STOCKPOINT for MUFG`
	}
	if (desc != '') {
		myDesc = desc
	}
	console.log('myDesc', myDesc)
	document.title = myTitle
	document.querySelector("meta[property='og:title']").setAttribute('content', myTitle)
	document.querySelector("meta[name='description']").setAttribute('content', myDesc)
	document.querySelector("meta[property='og:description']").setAttribute('content', myDesc)
}

